// i18next init — react-i18next + HTTP backend + language detector.
// Source : PRD 10 §6 i18n architecture.
//
// Pattern : les namespaces JSON sont servis depuis public/messages/{locale}/{ns}.json
// (fetch au premier accès namespace). Langue détectée via navigator, persistée
// en localStorage, override par profiles.language si connecté.
import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export const SUPPORTED_LOCALES = ["en", "fr", "de", "es", "it"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const NAMESPACES = [
  "common",
  "auth",
  "email",
  "crm",
  "tasks",
  "projects",
  "notes",
  "documents",
  "contacts",
  "companies",
  "settings",
  "landing",
  "legal",
  "notifications",
  "ai",
  "command",
] as const;

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LOCALES as unknown as string[],
    ns: NAMESPACES as unknown as string[],
    defaultNS: "common",
    backend: {
      loadPath: "/messages/{{lng}}/{{ns}}.json",
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "xymail-locale",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false, // React échappe déjà les XSS
    },
    react: {
      useSuspense: false, // géré par le Suspense wrapper routes
    },
  });

export { i18n };
